// extracted by mini-css-extract-plugin
export var active = "card-module--active--3NHiB";
export var cursor = "card-module--cursor--Rr1FD";
export var disabled = "card-module--disabled--iL-Mm";
export var error = "card-module--error--fzfB5";
export var link = "card-module--link--jSTjb";
export var noArrow = "card-module--noArrow--uOrVE";
export var root = "card-module--root--LPmQ2";
export var title = "card-module--title--7Kg9X";
export var warning = "card-module--warning--Pleom";